import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3655F2',
      light: '#EBEEFE'
    },
    success: {
      main: '#469E59'
    },
    warning: {
      main: '#F19E2B'
    },
    secondary: {
        main: '#E6E6E6'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none"
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "8px"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
        sizeMedium: {
          fontSize: 14,
          fontWeight: 500,
          borderRadius: 8
        }
      }
    }
  },
  typography: {
    h3: {
      fontWeight: 700,
      fontSize: 20
    },
    h4: {
      fontWeight: 700,
      fontSize: 16
    },
    h5: {
      fontWeight: 700,
      fontSize: 14
    },
    body1: {
      fontSize: 14,
      fontWeight: 400,
      color: '#1A1A1A'
    },
    body2: {
      fontSize: 12,
      fontWeight: 400
    },
    caption: {
      fontSize: 10,
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: 14,
      fontWeight: 500,
      color: "#666666"
    }
  }
});

export default theme;